module.exports = __webpack_public_path__ + "static/media/PDF_127.c0b11ac4.pdf";